import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  min-height: 100vh;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  font-family: var(--font-inter);
  padding: 16px;
  overflow: auto;
`;

const BgImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
`;

const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 22px 26px;
  background: #0e1118;
  border: 6px solid #9c3e3e;
  border-radius: 20px;
  box-sizing: border-box;
  width: 100%;
  max-width: 678px;
  min-width: 500px;

  @media (max-width: 600px) {
    min-width: unset;
    padding: 16px;
    gap: 16px;
    border-width: 4px;
    border-radius: 16px;
  }
`;

const MaintenanceLogo = styled.img`
  @media (max-width: 600px) {
    width: 46px;
    height: 56px;
  }
`;

const Title = styled.p`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  text-transform: uppercase;
  color: #ffffff;
  text-align: center;
  letter-spacing: 0;

  @media (max-width: 600px) {
    font-size: 16px;
  }
`;

const Message = styled.p`
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  letter-spacing: 0;

  @media (max-width: 600px) {
    font-size: 14px;
    line-height: 140%;
  }
`;

const DEFAULT_TITLE = "We'll be back soon";

type MaintenanceProps = {
  message?: string;
};

export function MaintenanceUi({ message }: MaintenanceProps) {
  return (
    <Container>
      <BgImage
        src="images/maintenance-bg-new.png"
        alt="Maintenance background"
      />
      <Card>
        <MaintenanceLogo
          src="images/maintenance-logo.svg"
          alt="Maintenance logo"
        ></MaintenanceLogo>
        <Title>{DEFAULT_TITLE}</Title>
        {message ? (
          <Message>{message}</Message>
        ) : (
          <Message>
            We are currently undergoing scheduled maintenance.
            <br></br>
            Please check back shortly.
          </Message>
        )}
      </Card>
    </Container>
  );
}
